import { Box, Container } from '@mui/material';
import React from 'react';

const PageFooter = () => {
	return <Box sx={{marginTop: 8}}>
		<Container></Container>
	</Box>;
};

export default PageFooter;
